/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAppointmentExclusionResponse } from './GetAppointmentExclusionResponse';
import {
    GetAppointmentExclusionResponseFromJSON,
    GetAppointmentExclusionResponseFromJSONTyped,
    GetAppointmentExclusionResponseToJSON,
    GetAppointmentExclusionResponseToJSONTyped,
} from './GetAppointmentExclusionResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetAppointmentExclusionResponse
 */
export interface PaginatedResultOfGetAppointmentExclusionResponse {
    /**
     * 
     * @type {Array<GetAppointmentExclusionResponse>}
     * @memberof PaginatedResultOfGetAppointmentExclusionResponse
     */
    items?: Array<GetAppointmentExclusionResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetAppointmentExclusionResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAppointmentExclusionResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAppointmentExclusionResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetAppointmentExclusionResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetAppointmentExclusionResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetAppointmentExclusionResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetAppointmentExclusionResponse interface.
 */
export function instanceOfPaginatedResultOfGetAppointmentExclusionResponse(value: object): value is PaginatedResultOfGetAppointmentExclusionResponse {
    return true;
}

export function PaginatedResultOfGetAppointmentExclusionResponseFromJSON(json: any): PaginatedResultOfGetAppointmentExclusionResponse {
    return PaginatedResultOfGetAppointmentExclusionResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetAppointmentExclusionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetAppointmentExclusionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetAppointmentExclusionResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetAppointmentExclusionResponseToJSON(json: any): PaginatedResultOfGetAppointmentExclusionResponse {
    return PaginatedResultOfGetAppointmentExclusionResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetAppointmentExclusionResponseToJSONTyped(value?: PaginatedResultOfGetAppointmentExclusionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetAppointmentExclusionResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

